import { gql } from '@apollo/client'

// Every target in the contract carries the same shape.
const TARGET_FIELDS = `
  kind
  contestId
  contestCode
  textMaterialId
  textMaterialSlug
  screen
  url
  params
`

export const GQL_QUERY_LANDING_PAGE = gql`
  query LandingPage($code: String, $id: ID) {
    landingPage(code: $code, id: $id) {
      id
      code
      name
      kind
      stateId
      header {
        showHeader
        variant
        logo {
          image
          title
          target { ${TARGET_FIELDS} }
        }
        search {
          enabled
          placeholder
          categoryId
          filter
          target { ${TARGET_FIELDS} }
        }
        hero {
          type
          bannerId
          storyId
          payload
        }
      }
      actions {
        id
        type
        payload
        target { ${TARGET_FIELDS} }
      }
      blocks {
        id
        type
        subtype
        order
        visibleForStates
        payload
        target { ${TARGET_FIELDS} }
      }
      promo {
        participating
        earnedChances
        usedChances
        availableWheelChances
        contest {
          id
          code
          actionId
        }
      }
    }
  }
`
